import axios from 'axios';
// const baseURL= process.env.REACT_APP_BACK_END_URL
// const baseURL="http://localhost:5000/"
// const baseURL="https://13.201.108.246:5000/"
const baseURL="https://yogamatic.in/api"
console.log("REACT_APP_BACKEND_URL", process.env.REACT_APP_FRONTEND_URL)

console.log("baseURL,baseURL",baseURL)

const Axios = axios.create({
   baseURL: baseURL,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "accept-language": "en",
      },
});

Axios.interceptors.request.use(
    async function (config) {
        // Public routes that don't need authentication
        const publicRoutes = [
            '/upload',
            '/yoga_services',
            '/events',
            '/cx_rating'
        ];
        
        // Check if the request URL is a public route
        const isPublicRoute = publicRoutes.some(route => config.url?.includes(route));
        
        // Only add token if it's not a public route
        if (!isPublicRoute) {
            const getToken = localStorage.getItem('token');
            const token = getToken;

            if (token) {
                config.headers['token'] = token;
            }
        }
        
        console.log("configinterceptor", config)
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

Axios.interceptors.response.use(
    (response) => {
        
        return response;
    },
    (error) => {
        console.log('Axios Error -->>', error);
        if (error.response.status == 401 || error.response.status == 403) {
        localStorage.clear();
        // window.location.replace('/login');
        }
        return Promise.reject(error);
    }
);

export default Axios;